import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["text"];

var _templateObject;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PREFIX_MAX_CHARACTERS_ALLOWED } from "../constants";
import { getRem } from "./../../core";
import { BaseInputPrefixSuffix } from "./BaseInputPrefixSuffix";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledInputPrefix = styled(BaseInputPrefixSuffix)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-right: ", ";\n"])), getRem('2px'));

var InputPrefix = function InputPrefix(_ref) {
  var text = _ref.text,
      other = _objectWithoutProperties(_ref, _excluded);

  var formattedText = text.substring(0, PREFIX_MAX_CHARACTERS_ALLOWED);
  return /*#__PURE__*/_jsx(StyledInputPrefix, _objectSpread(_objectSpread({}, other), {}, {
    children: formattedText
  }));
};

InputPrefix.displayName = "InputPrefix";
InputPrefix.propTypes = {
  /** Unique identifier. Necessary to have for linking with input */
  id: PropTypes.string.isRequired,

  /** If true, adjusts label styling */
  isDisabled: PropTypes.bool,

  /** Displays provided text string up to 1 character */
  text: PropTypes.node.isRequired
};
InputPrefix.defaultProps = {
  isDisabled: false
};
export { InputPrefix };